rwgps = window.rwgps || {};

rwgps.Route = function (data, map, options) {
  this.segments = [];
  this.distance = 0;
  this.startMarker = null;
  this.endMarker = null;
  this.gBounds = new google.maps.LatLngBounds();
  this.locality = null;
  this.postalCode = null;
  this.administrativeArea = null;
  this.countryCode = null;
  this.map = map;
  this.metricsChangeCallbacks = [];
  this.mysqlId = null;
  this.mongoidId = null;
  this.photoIds = [];
  this.userId = null;
  this.drawInactive = true;
  this.pois = [];

  var setShowSurface = (data) => {
    if (!rwgps.config.labs.surface_types) {
      return false
    }
    if (data) {
      return data.showSurface || !_.some(data.track_points, p => p['S'] === undefined)
    } else {
      return true
    }
  }

  this.showSurface = setShowSurface(data);

  if (data) {
    this.initFromDataJSON(data, options);
  }
}

rwgps.Route.DEFAULT_LINE_WIDTH = 4;
// the default line color gets overridden and is actively used --
// original is just to figure out if the user built the route on rwgps
// and changed colors or not
rwgps.Route.ORIGINAL_DEFAULT_LINE_COLOR = 0xFF0000;
rwgps.Route.DEFAULT_LINE_COLOR = 0xFF0000;

rwgps.Route.prototype = {
  setModified: function() {
    this._dirty = true;
    rwgps.Events.trigger('route:modified', this);
  },
  isModified: function() {
    return this._dirty;
  },
  setMap: function(map) {
    this.map = map;
    _.each(this.segments, function(seg) {
      seg.map = map;
    });
  },
  deleteCoursePoints: function() {
    _.each(this.segments, function(seg) {
      _.each(seg.coursePoints, function(cp) {
        if(cp.row) cp.row.remove();
        if(cp.marker && cp.marker.gmarker) cp.marker.gmarker.setMap(null);
      });
      seg.coursePoints = [];
    });
  },
  segments: function(i) {
    if(i) {
      var seg = this.firstSegment;
      while(i--) seg = seg.nextSegment;
      return seg;
    }
  },
  segmentsChanged: function(newSegment) {
    this.segments = [];
    var seg=this.firstSegment, count=0;
    var seen = {};
    if(seg) {
      count=1;
      do {
        if(seen[seg._segId]) {
          break;
        }
        seen[seg._segId] = true;
        seg.route = this;
        this.segments.push(seg);
        count++;
        seg = seg.nextSegment;
      } while(seg);
      this.lastSegment = this.segments[this.segments.length-1];
    }

    // clear trackpoints cache
    delete this._trackPoints;
    if(this.map && this.map.activeRoute === this)
      delete this.map.routePoints;

    // update connection point trackPoint if it exists
    if(this.connectionPointIcon && this.firstSegment) {
      this.connectionPointIcon.trackPoint = this.firstSegment.prevControlPoint;
    }

    if(newSegment) {
      //since segments assign distances to trackPoints on creation, we have to
      //add in the route's current distance to the segs trackpoints when appending
      //also collect LatLng's for assigning to polyline, as well as bounds
      if(newSegment.prevControlPoint && newSegment.prevControlPoint.point)
        this.gBounds.extend(newSegment.prevControlPoint.googleLatLng());
      if(newSegment.nextControlPoint && newSegment.nextControlPoint.point)
        this.gBounds.extend(newSegment.nextControlPoint.googleLatLng());
      for(var i = 0; i < newSegment.trackPoints.length; i++) {
        var tp = newSegment.trackPoints[i];
        if(tp.point) this.gBounds.extend(tp.googleLatLng()); //add to our bounds set
      }
      if(newSegment.coursePoints) {
        for(i = 0; i < newSegment.coursePoints.length; i++) {
          var cp = newSegment.coursePoints[i];
          cp.distance = cp.trackPoint.distance;
          cp.route = this;
        }
      }
    }
  },
  createSegmentBoundariesForSlice: function(dataSlice) {
    var tps = this.trackPoints(),
        firstPt = tps[dataSlice.i],
        lastPt = tps[dataSlice.i + dataSlice.count - 1];
    // split segs on crop boundaries
    if(!firstPt.isControlPoint) {
      var firstPtSegmentI = _.indexOf(firstPt.segment.trackPoints, firstPt);
      firstPt.segment.splitAfter(firstPtSegmentI-1);
    }
    if(!lastPt.isControlPoint) {
      var lastPtSegmentI = _.indexOf(lastPt.segment.trackPoints, lastPt);
      lastPt.segment.splitAfter(lastPtSegmentI-1);
    }
  },
  removeSlice: function(dataSlice) {
    var tps = this.trackPoints(),
        firstPt = tps[dataSlice.i],
        lastPt = tps[dataSlice.i + dataSlice.count - 1],
        newRoute,
        segs;

    this.createSegmentBoundariesForSlice(dataSlice);

    if(dataSlice.i === 0) {
      segs = [lastPt.prevSegment];
      while(segs[0].prevSegment) { segs.unshift(segs[0].prevSegment); }
      _.each(segs, function(seg) { this.removeSegment(seg); }, this);
      this.firstSegment = lastPt.nextSegment;
      this.segmentsChanged();
      this.calculateMetrics();
      this.startMarker.gmarker.setPosition(lastPt.googleLatLng());
    } else {
      if(lastPt.nextSegment) {
        newRoute = new rwgps.Route(null, this.map);
        this.map.routes.push(newRoute);
        newRoute.firstSegment = lastPt.nextSegment;
        lastPt.prevSegment.nextSegment = null;
        lastPt.setPrevSegment(null);
        newRoute.segmentsChanged();
        newRoute.rebuildBounds();
        newRoute.calculateMetrics();
        newRoute.setInactive(true);
      } else if(this.endMarker) {
        this.endMarker.gmarker.setPosition(firstPt.googleLatLng());
      }

      segs = [firstPt.nextSegment];
      while(segs[0].nextSegment) { segs.unshift(segs[0].nextSegment); }
      _.each(segs, function(seg) { this.removeSegment(seg); }, this);

      this.redrawPolylines();
      this.map.prevClick = firstPt.point;
    }


    this.map.drawRouteDistanceMarkers();
    this.map.loadElevationProfile();
    this.map.populateCuesheet(this.coursePoints());
    this.map.snapshot();
    rwgps.Events.trigger('map:routes_changed');
    return newRoute;
  },
  cropTo: function(dataSlice) {
    var tps = this.trackPoints(),
        firstPt = tps[dataSlice.i],
        lastPt = tps[dataSlice.i + dataSlice.count - 1];
    this.createSegmentBoundariesForSlice(dataSlice);
    // remove segments from outside to inside
    var segs = [];
    if(firstPt.prevSegment) {
      segs.unshift(firstPt.prevSegment);
      while(segs[0].prevSegment) {
        segs.unshift(segs[0].prevSegment);
      }
    }
    if(lastPt.nextSegment) {
      segs.unshift(lastPt.nextSegment);
      while(segs[0].nextSegment) {
        segs.unshift(segs[0].nextSegment);
      }
    }
    _.each(segs, function(seg) {
      this.removeSegment(seg);
    }, this);
    this.firstSegment = firstPt.nextSegment;
    this.segmentsChanged();
    this.calculateMetrics();
    this.rebuildBounds();

    // if there are coursepoints attached to the endpoints of our crop get rid of them
    var firstCp = firstPt.nextSegment.coursePoints[0];
    if(firstCp && firstCp.trackPoint === firstPt)
      firstPt.nextSegment.coursePoints.splice(0, 1);
    var lastCps = lastPt.prevSegment.coursePoints,
        lastCp = lastCps[lastCps.length-1];
    if(lastCp && lastCp.trackPoint === lastPt)
      lastCps.splice(lastCps.length-1);

    this.startMarker.gmarker.setPosition(firstPt.googleLatLng());
    if(this.endMarker)
      this.endMarker.gmarker.setPosition(lastPt.googleLatLng());
    this.map.prevClick = dataSlice.lastPoint().point;
    this.map.drawRouteDistanceMarkers();
    this.map.loadElevationProfile();
    this.map.populateCuesheet(this.coursePoints());
    this.map.snapshot();
  },
  removeTrack: function() {
    _.each(this.segments, function(seg) {
      this.removeSegment(seg);
    }, this);
    if(this.active) {
      this.map.prevClick = null;
      this.clearStartMarker();
      this.map.removeRouteDistanceMarkers(this);
    }
  },
  customColorsUsed: function() {
    return this.customColors || false;
  },
  hasPower: function() {
    var rand, hasPower = false, tps = this.trackPoints();
    for(var i = 0; i < 10; i++) {
      rand = Math.floor(Math.random()*tps.length);
      hasPower = tps[rand].watts != null;
    }
    return hasPower;
  },
  storeRawPower: function() {
    //avoid overwriting the original
    if(this.storedPower && this.storedPower.length > 0) return;
    var tp = this.trackPoints();
    this.storedPower = new Array(tp.length);
    for(var i = 0; i < tp.length; i++) this.storedPower[i] = tp[i].watts;
  },
  restoreRawPower: function() {
    if(this.storedPower == null || this.storedPower.length == 0) return;
    var tp = this.trackPoints();
    for(var i = 0; i < tp.length; i++) tp[i].watts = this.storedPower[i];
  },
  replacePowerWithAvg: function(windowsize) {
    var tp = this.trackPoints();
    if(tp.length == 0) return;
    if(this.hasPower() == false) return;

    //tuck away our original power data so we don't lose it
    this.storePower();

    var i = 0, j = 0, watts = [];
    var side = Math.floor((windowsize||3)/2);
    var start = side * -1, end = side;

    for(i = 0; i < tp.length; i++) {
      var window = [];
      for(j = start; j <= end; j++) {
        if((i + j >= 0) && (i + j < tp.length))
          window.push(tp[i+j].watts);
      }
      var sum = 0, count = 0;
      for(j = 0; j < window.length; j++) {
        if(window[j] != null) {
          sum += window[j];
          count += 1;
        }
      }
      //if(sum != undefined && count) watts.push(sum / count);
      //watts.push(sum && count ? sum / count : tp[i].watts);
      watts.push(sum/count);
    }

    for(i = 0; i < tp.length; i++) tp[i].watts = watts[i];
    //return watts;
  },
  // need to null out grade figures if we want metrics calculator to recalc grade for us.
  resetGrade: function() {
    var tps = this._trackPoints;
    if(!tps) return;
    for(var i=0; i < tps.length; i++) {
      tps[i].grade = tps[i].grade_orig = null;
    }
  },
  flattenBridgesAndTunnels: function() {
    let leftI, rightI;
    let flattening = false;
    const trackPoints = this.trackPoints();
    const tpLen = trackPoints.length;
    // use this to smooth boundaries on the assumption that the grade
    // of ways entering/exiting tunnels and bridges will be smooth
    const buffer = 20; // meters.

    _.forEach(trackPoints, (pt, idx) => {
      if (pt.flattened) return // already flattened this range
      if (pt.roadEnv && !flattening) {
        flattening = true;
        leftI = idx;
        // last non-bridge/tunnel pt, plus buffer
        while ((trackPoints[idx].distance - trackPoints[leftI].distance) < buffer && leftI > 0) {
          leftI = leftI - 1;
        }
      } else if (flattening && pt.roadEnv === 0) {
        flattening = false;
        rightI = idx;
        // first non-bridge/tunnel pt, plus buffer
        while ((trackPoints[rightI].distance - trackPoints[idx].distance) < buffer && rightI < tpLen) {
          rightI = rightI + 1;
        }

        var firstPt = trackPoints[leftI],
          lastPt = trackPoints[rightI],
          domain = "distance",
          domainOffset = firstPt[domain],
          mult = (lastPt.ele - firstPt.ele) / (lastPt[domain] - firstPt[domain]);
        _.forEach(trackPoints.slice(leftI, rightI), function(pt) {
          pt.ele = (pt[domain] - domainOffset) * mult + firstPt.ele;
          pt.flattened = true;
        });
      }
    })
  },
  trackPoints: function() {
    if(!this._trackPoints) {
      var pts = [], seg = this.firstSegment;
      while(seg) {
        pts.push(seg.prevControlPoint);
        for(var i = 0; i < seg.trackPoints.length; i++) {
          pts.push(seg.trackPoints[i]);
        }
        if(!seg.nextSegment)
          pts.push(seg.nextControlPoint);
        seg = seg.nextSegment;
      }
      this._trackPoints = pts;
    }
    return this._trackPoints;
  },
  coursePoints: function() {
    var pts = [];
    for(var i = 0; i < this.segments.length; i++) {
      pts = pts.concat(this.segments[i].coursePoints);
    }
    return pts;
  },
  elevationGain: function() {
    var total = 0;
    for(var i = 0; i < this.segments.length; i++) {
      total += this.segments[i].elevationGain;
    }
    return total;
  },
  elevationLoss: function() {
    var total = 0;
    for(var i = 0; i < this.segments.length; i++) {
      total += this.segments[i].elevationLoss;
    }
    return total;
  },

  //TODO: maybe change to just 'if(this.map)' ?? make route
  //and segments aware of their respective maps?
  isOnMap: function() {
    if((this.startMarker && this.startMarker.gmarker.map) ||
    (this.endMarker && this.endMarker.gmarker.map) ||
    (this.segments.length > 0 && this.segments[0].gPolylines[0].map)) {
      return true;
    } else {
      return false;
    }
  },

  removeFromMap: function() {
    if(this.startMarker && this.startMarker.gmarker)
      this.startMarker.gmarker.setMap(null);
    if(this.endMarker && this.endMarker.gmarker)
      this.endMarker.gmarker.setMap(null);
    for(var i = 0; i < this.segments.length; i++) {
      this.segments[i].gPolylines.forEach(pl => pl.setMap(null));
      this.segments[i].sPolylines.forEach(pl => pl.setMap(null));
      if(this.segments[i].backgroundPolyline)
        this.segments[i].backgroundPolyline.setMap(null);
    }
    for(i = 0; i < this.map.routes.length; i++) {
      if(this.map.routes[i] == this) {
        this.map.routes.remove(i, i+1);
        break;
      }
    }
  },

  setActive: function() {
    if(this.active) return;
    this.active = true;
    // redraw route so it looks active and has control points
    this.redraw();
  },

  setInactive: function(force) {
    if(!this.active && !force) return;
    this.active = false;
    if (this.map) this.map.removeRouteDistanceMarkers(this)
    // redraw route so it looks inactive
    this.redraw();
  },

  clearConnectionPoint: function() {
    if(this.connectionPointIcon)
      this.connectionPointIcon.gmarker.setMap(null);
  },

  drawConnectionPoint: function() {
    if(this.connectionPointDisabled) return;
    var pt = this.trackPoints()[0];
    if(this.connectionPointIcon) {
      this.connectionPointIcon.gmarker.setMap(this.map.gmap);
      this.connectionPointIcon.gmarker.setPosition(pt.googleLatLng());
      this.connectionPointIcon.trackPoint = pt;
    } else {
      var icon = new rwgps.ConnectionPointIcon(pt, this.map);
      this.connectionPointIcon = icon;
    }
  },

  initFromDataJSON: function(raw, options) {
    var data = (typeof raw == "string" ? $.evalJSON(raw) : raw);
    var i = 0, j = 0;
    var coursePoints = data.course_points || [];
    var trackPoints = data.track_points || [];
    this.drawInactive = data.drawInactive === undefined ? true : data.drawInactive;
    this.connectionPointDisabled = data.connectionPointDisabled;
    var cps = [], pts = [], segs = [], clickIndexes = [], seg;
    if(data.id) this.mysqlId = data.id;
    if(data.mongoid_id) this.mongoidId = data.mongoid_id;
    if(data.photo_ids && data.photo_ids.length > 0) this.photoIds = data.photo_ids;
    if(data.user_id) this.userId = data.user_id;

    // NOTE: if we're handed data without surface information, then never draw st on 
    // 1. tracklines
    // 2. samplegraph
    // 3. left sidepanel
    this.showSurface = rwgps.config.labs.surface_types && (!_.some(trackPoints, tp => tp['S'] === undefined) || trackPoints.length === 0)

    this.name = raw.name;

    this.routeData = {
      name: raw.name,
      id: raw.id,
      description: raw.description,
      isTrip: options && options.isTrip
    };

    this.pois = _.map((data.points_of_interest || []), function(poi) {
      if (_.isFunction(poi.toSaveObj)) {
        return poi;
      } else {
        return rwgps.PointOfInterest.fromJSON([poi], !(options || {}).planning)[0];
      }
    });

    var tpsResult = rwgps.TrackPoint.fromJSON(trackPoints, options);
    pts = tpsResult.trackPoints;
    if (options && options.isTrip && !_.every(pts, tp => tp.surface)) {
      this.map.injectSurfaces(pts, () => {})
    }
    clickIndexes = tpsResult.clickIndexes;

    var startIndex = 1;
    var prevCp = pts[0];
    for(i = 0; i < clickIndexes.length; i++) {
      var endIndex = clickIndexes[i];
      if(endIndex === 0) continue; // don't allow 0 length initial segment -- seen in wild

      var points = pts.slice(startIndex, endIndex);

      if(trackPoints[endIndex]["color"] != rwgps.Route.ORIGINAL_DEFAULT_LINE_COLOR) {
        this.customColors = true;
      }

      seg = new rwgps.Segment(this, prevCp, pts[endIndex], points, null, trackPoints[endIndex]["color"]);
      seg.clickOptions.setOptions(trackPoints[endIndex]["options"]);
      segs.push(seg);
      prevCp = pts[endIndex];

      startIndex = endIndex+1;
    }

    //stored trip, no clicks, colors or options
    //must have trackpoints, else exception happens
    if(clickIndexes.length == 0 && pts.length > 0) {
      segs.push(new rwgps.Segment(this, pts[0], pts[pts.length-1], pts.slice(1, -1)));
    }

    var cp;
    for(i = 0; i < coursePoints.length; i++) {
      cp = coursePoints[i];
      cps.push(new rwgps.CoursePoint({
        edited: cp._e,
        point: {lat: cp.y, lng: cp.x},
        notes: cp.n,
        type: cp.t,
        description: cp.description,
        trackPointIndex: cp.i,
        distance: cp.d,
        photoIds: cp.photo_ids,
        confirmed: cp.c
      }));
    }

    //match coursepoints with trackpoints.
    var nextStartIndex = 0;
    for(i = 0; i < cps.length; i++) {
      cp = cps[i];
      if(pts[cp.trackPointIndex]) {
        cp.trackPoint = pts[cp.trackPointIndex];
      } else { //older route, no trackpointindex, find closest
        var eps = 0.0001;
        //var matched = false;
        for(j = nextStartIndex; j < pts.length; j++) {
          var tp = pts[j];
          if(tp.point && Math.abs(cp.point.lat - tp.point.lat) <= eps && Math.abs(cp.point.lng - tp.point.lng) <= eps) {
            //matched = true;
            nextStartIndex = j+1;
            cp.trackPointIndex = j;
            cp.trackPoint = tp;
            break;
          }
        }
        //if(matched == false) trace("no match found");
      }
      if(cp.trackPoint) {
        if(cp.trackPoint.segment) {
          cp.segment = cp.trackPoint.segment;
          cp.trackPoint.segment.coursePoints.push(cp);
        } else {
          //find a segment to stick the point onto...
          //needed for semi-common case of coursepoints falling on segment
          //start/end points, and thus not having an assigned segment
          if(cp.trackPoint.prevSegment) {
            cp.segment = cp.trackPoint.prevSegment;
            cp.trackPoint.prevSegment.coursePoints.push(cp);
          } else { //if no prev segment, must be the first segment
            cp.segment = segs[0];
            segs[0].coursePoints.push(cp);
          }
        }
      }
    }

    this.rebuildBounds();
    this.calculateMetrics();
  },
  trackPointsForSave: function() {
    var tps = [], seg;
    for(var j = 0; j < this.segments.length; j++) {
      seg = this.segments[j];
      // push first point
      if(j === 0)
        tps.push(seg.prevControlPoint.toMiniObj());
      for(var i = 0; i < seg.trackPoints.length; i++) {
        var pt = seg.trackPoints[i];
        tps.push(pt.toMiniObj());
      }
      tps.push(seg.nextControlPoint.toMiniObj());
      tps[tps.length-1]["options"] = seg.clickOptions.getOptions();
      tps[tps.length-1]["color"] = seg.color;
    }
    return tps;
  },
  coursePointsForSave: function() {
    var trackPoints = this.trackPoints(); //true is for de-duping
    var coursePoints = this.coursePoints();
    var cps = [];
    for(var i = 0; i < coursePoints.length; i++) {
      var cp = coursePoints[i];
      cp.trackPointIndex = _.indexOf(trackPoints, cp.trackPoint);
      cps.push(cp.toMiniObj());
    }
    return cps;
  },

  toSaveObj: function() {
    return {
      id: this.mysqlId,
      name: this.name,
      active: this.active,
      track_points: this.trackPointsForSave(),
      course_points: this.coursePointsForSave(),
      drawInactive: this.drawInactive,
      connectionPointDisabled: this.connectionPointDisabled,
      isTrip: this.routeData && this.routeData.isTrip,
      showSurface: this.showSurface
    }
  },

  metrics: {},
  calculateMetrics: function() {
    // TODO: use this! return rwgps.MetricsCalculator.aggregate.apply(rwgps.MetricsCalculator, _.map(this.segments, function(seg) { return seg.metrics; }));
    this.metricsCalculator = new rwgps.MetricsCalculator(this.trackPoints())
    this.metrics = this.metricsCalculator.calculate()
    _.each(this.coursePoints(), function(cp) { cp.distance = cp.trackPoint.distance; } )
    this.metricsChange()
  },
  metricsChangeCallbacks: [],
  // listen for or trigger metricsChange
  metricsChange: function(fn) {
    if(fn) { //listen
      this.metricsChangeCallbacks.push(fn);
    } else { //trigger
      let that = this
      _.each(this.metricsChangeCallbacks, function(fn) { fn(that) });
    }
  },

  removeSegment: function(segment) {
    segment.removeFromMap();
    segment.prevControlPoint.setNextSegment(null);
    segment.nextControlPoint.setPrevSegment(null);
    if(this.firstSegment === segment) this.firstSegment = null;
    this.segmentsChanged();
    this.calculateMetrics();
    this.rebuildBounds();
  },

  rebuildBounds: function() {
    this.gBounds = new google.maps.LatLngBounds();
    var trackPoints = this.trackPoints();
    for(var i=0; i < trackPoints.length; i++) {
      var tp = trackPoints[i];
      if(tp.point)
        this.gBounds.extend(tp.googleLatLng()); //add to our bounds set
    }
  },

  drawPreview: function() {
    if(this.previewPolyline) {
      this.previewPolyline.setMap(this.map.gmap)
      return
    }

    var trackPoints = this.trackPoints();
    var lls = [];
    for(var i = 0; i < trackPoints.length; i++) {
      var tp = trackPoints[i];
      if(tp.point) lls.push(tp.googleLatLng());
    }
    if(lls.length > 0) {
      var style = this.previewStyle || {
        strokeColor: '#0000ff',
        strokeOpacity: 0.4,
        strokeWeight: 10
      }
      this.previewPolyline = new google.maps.Polyline(_.extend(style, {
        map: this.map.gmap,
        path: lls,
        clickable: false
      }));
    }
  },
  clearPreview: function() {
    if(this.previewPolyline) {
      this.previewPolyline.setMap(null);
    }
  },
  redraw: function() {
    this.clearAllOverlays();
    if(this.active || this.drawInactive) {
      if(this.active) {
        if(this.startMarker)
          this.startMarker.gmarker.setMap(this.map.gmap);
        else if(this.firstSegment)
          this.startMarker = new rwgps.StartIcon(this.firstSegment.prevControlPoint.point, this.map);
        if(this.map.mode === 'view') {
          if(this.endMarker)
            this.endMarker.gmarker.setMap(this.map.gmap);
          else if(this.lastSegment)
            this.endMarker = new rwgps.EndIcon(this.lastSegment.nextControlPoint.point, this.map);
        }
      } else if(this.map.inPlanningMode()) {
        this.drawConnectionPoint();
      }
      this.redrawPolylines();
    }
  },

  clearAllOverlays: function() {
    this.clearPreview();
    this.clearCoursePointMarkers();
    this.clearStartMarker();
    this.clearEndMarker();
    this.clearPolylines();
    this.clearControlPoints();
    this.clearConnectionPoint();
  },
  clearCoursePointMarkers: function() {
    for(var i = 0; i < this.segments.length; i++) {
      for(var j = 0; j < this.segments[i].coursePoints.length; j++) {
        if(this.segments[i].coursePoints[j].marker)
          this.segments[i].coursePoints[j].marker.gmarker.setMap(null);
        //TODO: should we null out marker?
      }
    }
  },
  clearStartMarker: function() {
    if(this.startMarker) this.startMarker.gmarker.setMap(null);
  },
  clearEndMarker: function() {
    if(this.endMarker) this.endMarker.gmarker.setMap(null);
  },
  drawPolylines: function(map) {
    _.each(this.segments, function(seg) {
      if(seg.gPolylines.length > 0) {
        if(seg.backgroundPolyline) seg.backgroundPolyline.setMap(map.gmap);
        seg.gPolylines.forEach(pl => pl.setMap(map.gmap));
        if (map.opts.showSurface) {
          seg.sPolylines.forEach(pl => pl.setMap(map.gmap));
        }
      } else {
        seg.render();
      }
    });
  },
  clearPolylines: function() {
    for(var i = 0; i < this.segments.length; i++) {
      if(this.segments[i].backgroundPolyline) this.segments[i].backgroundPolyline.setMap(null);
      if(this.segments[i].gPolylines.length > 0) {
        this.segments[i].gPolylines.forEach(pl => pl.setMap(null));
        this.segments[i].sPolylines.forEach(pl => pl.setMap(null));
      }
    }
  },
  redrawPolylines: function() {
    for(var i = 0; i < this.segments.length; i++) {
      if(this.segments[i].backgroundPolyline) {
        this.segments[i].backgroundPolyline.setMap(null);
        this.segments[i].backgroundPolyline = null;
      }
      if(this.segments[i].gPolylines.length > 0) {
        this.segments[i].gPolylines.forEach(pl => pl.setMap(null));
        this.segments[i].gPolylines = [];
        this.segments[i].sPolylines.forEach(pl => pl.setMap(null));
        this.segments[i].sPolylines = [];
      }
    }
    this.drawPolylines(this.map);
  },

  recalculatePolylines: function () {
    this.segments.forEach(s => s.recalculateSurfaces())
  },

  //TODO: should segments should own their icon?
  drawControlPoints: function(map) {
    _.each(this.segments, function(seg) {
      seg.drawControlPoint(map);
    });
  },
  clearControlPoints: function() {
    _.each(this.segments, function(seg) {
      if(seg.controlPointIcon) seg.controlPointIcon.gmarker.setMap(null);
    });
  },

  distanceToLatLng: function(googleLatLng, map) {
    // A bunch of this code was copied over from findNearestPoint() in map.js
    var tps = this.trackPoints();
    var mousePoint = map.googleLatLngToPoint(googleLatLng);
    var mouseX = mousePoint.x;
    var mouseY = mousePoint.y;

    var _routePoints = [];
    for(var j = 0; j < tps.length; j++) {
      if(tps[j].point) {
        var pt = map.googleLatLngToPoint(tps[j].googleLatLng());
        _routePoints.push(pt.x);
        _routePoints.push(pt.y);
        _routePoints.push(tps[j]);
      } else {
        _routePoints.push(null)
        _routePoints.push(null)
        _routePoints.push(null)
      }
    }

    var minDist = Number.MAX_VALUE;
    var minX = _routePoints[0];
    var minY = _routePoints[1];
    var x = minX;
    var y = minY;
    var i, lowI;
    for(i = 0; i < _routePoints.length; i += 3) {
      var x0 = x;
      var y0 = y;
      x = _routePoints[i];
      y = _routePoints[i+1];

      if(x == null || y == null) continue;

      var dx = x - x0;
      var dy = y - y0;
      var d = dx*dx + dy*dy;

      var u = ((mouseX - x)*dx + (mouseY - y)*dy) / d;
      var x2 = x + (u*dx);
      var y2 = y + (u*dy);
      var dist = (mouseX - x2)*(mouseX - x2) + (mouseY - y2)*(mouseY - y2);
      if(dist < minDist) {
        var d1 = (mouseX - x0)*(mouseX - x0) + (mouseY - y0)*(mouseY - y0);
        var d2 = (mouseX - x)*(mouseX - x) + (mouseY - y)*(mouseY - y);
        if((d1 - dist) + (d2 - dist) > d) {
          if(d1 < d2) {
            dist = d1;
            x2 = x0;
            y2 = y0;
          } else {
            dist = d2;
            x2 = x;
            y2 = y;
          }
        }
      }

      if(dist < minDist) {
        minDist = dist;
        minX = x2;
        minY = y2;
        lowI = i - 1;
      }
    }
    var lowTpsI = (lowI-2) / 3,
        low = tps[lowTpsI];

    if(low && low.point) {
      return low.distanceFromLatLng({lat: googleLatLng.lat(), lng: googleLatLng.lng()})
    }
  },
  hasHighlightedSegment: function () {
    // return whether all the segments are not supposed to be drawnInactive
    return !_.every(this.segments, (segment) => segment.drawInactive !== true)
  }
}
var segId = 0;
rwgps.Segment = function(route, prevControlPoint, nextControlPoint, trackPoints, coursePoints, color) {
  this._segId = segId++;
  if(!trackPoints) trackPoints = [];
  var i = 0;

  // connectors
  prevControlPoint.setNextSegment(this);
  nextControlPoint.setPrevSegment(this);

  this.map = route.map;
  this.distance = 0;
  this.elevationGain = 0;
  this.elevationLoss = 0;
  this.color = (_.isNumber(color) && !isNaN(color)) ? color : rwgps.Route.DEFAULT_LINE_COLOR;
  this.clickOptions = new rwgps.ClickOptions();
  this.gPolylines = [];
  this.sPolylines = [];
  this.backgroundPolyline = null;
  this.trackPoints = trackPoints;
  this.coursePoints = coursePoints || [];
  this.controlPointIcon = null;
  this.distanceMarkers = [];

  //since segments assign distances to trackPoints on creation, we have to
  //add in the route's current distance to the segs trackpoints when appending
  //also collect LatLng's for assigning to polyline, as well as bounds
  this.distance = nextControlPoint.distance - prevControlPoint.distance;

  for (i = 0; i < trackPoints.length; i++) {
    trackPoints[i].segment = this;
  }

  this.calculateSurfaceIndices();

  // coursepoints need a ref to segment as well as distance
  if(coursePoints) {
    for(i = 0; i < coursePoints.length; i++) {
      coursePoints[i].segment = this;
    }
  }
  this.route = route;
  if(!this.prevSegment) {
    this.route.firstSegment = this;
  }

  this.detectAndSetExcludeFromMetrics()

  this.route.segmentsChanged(this); // recalc # segments and cache
  if(this.route.active)
    this.render();
}

rwgps.Segment.cssColor = function(color_int) {
  var color = color_int < 0 ? "0" : color_int.toString(16);
  while(color.length < 6) color = "0" + color;
  return "#" + color.toUpperCase();
}

rwgps.Segment.prototype = {
  calculateSurfaceIndices: function () {
    if (!rwgps.surfaces) {
      return
    }
    this.surfaceIndices = [];
    const trackPoints = this.trackPoints;
    if (!this.prevControlPoint && trackPoints.length === 0 && !this.nextControlPoint) {
      return
    }
    let toCheck = [];
    if (this.prevControlPoint.point) toCheck.push(this.prevControlPoint);
    trackPoints.forEach(tp => { tp.point && toCheck.push(tp) });
    if (this.nextControlPoint.point) toCheck.push(this.nextControlPoint);

    let tp, thisTpSurfaceGroup, lastTpSurfaceGroup = rwgps.surfaces.surfaceGroups[toCheck[0].surface];
    for (let i = 0; i < toCheck.length; i++) {
      tp = toCheck[i];
      // SURFACE: add to surfaceIndices when last tp is in a different group than this tp
      if (rwgps.surfaces && i > 1) {
        thisTpSurfaceGroup = rwgps.surfaces.surfaceGroups[tp.surface];
        if (lastTpSurfaceGroup !== thisTpSurfaceGroup) {
          lastTpSurfaceGroup = thisTpSurfaceGroup;
          this.surfaceIndices.push(i);
        }
      }
    }
  },

  detectAndSetExcludeFromMetrics: function() {
    // set initial excludeFromMetrics state to enforce data integrity during planning, and properly render while viewing
    if (this.prevControlPoint.excludeFromMetrics !== this.nextControlPoint.excludeFromMetrics)
      this.setExcludeFromMetrics(false);
    else if (this.prevControlPoint.excludeFromMetrics && this.nextControlPoint.excludeFromMetrics) {
      this.setExcludeFromMetrics(this.trackPoints.length === 0 || this.trackPoints[0].excludeFromMetrics);
    }
  },

  setExcludeFromMetrics: function (exclude, updateTrackPoints) {
    this.excludeFromMetrics = exclude

    // excludeFromMetrics needs to be inclusively set on all points in excluded range.
    // during planning/editing this method does the property setting, during viewing this is superfluous (values already set properly)
    //
    // if a prev/next segment is to remain excluded (and we are un-excluding this segment) then
    // we can't change the exclude status of our control points, since exclude is set inclusively
    const controlPointsToChange = []
    if (!this.prevSegment || !this.prevSegment.excludeFromMetrics)
      controlPointsToChange.push(this.prevControlPoint)
    if (!this.nextSegment || !this.nextSegment.excludeFromMetrics)
      controlPointsToChange.push(this.nextControlPoint)
    ;[controlPointsToChange, this.trackPoints].forEach(arr => {
      arr.forEach(tp => {
        if (updateTrackPoints) {
          tp.excludeFromMetrics = exclude // this gets persisted
          // trackPoint.exclude is not persisted, but tells metrics calc the user was stopped/data was bad (prevents being used in aggregations)
          if (exclude) {
            if (tp._exclude === undefined) tp._exclude = !!tp.exclude
            tp.exclude = true
          } else {
            if (tp._exclude !== undefined) tp.exclude = tp._exclude
          }
        }
      })
    })
  },

  recalculateSurfaces: function () {
    this.gPolylines.forEach(pl => pl.setMap(null));
    this.gPolylines = [];
    this.sPolylines.forEach(pl => pl.setMap(null));
    this.sPolylines = [];
    this.calculateSurfaceIndices()
    this.render()
  },

  showSurface: function () {
    // don't draw surface unless we have surface info, regardless of pref
    if (!this.route.showSurface || !(this.prevControlPoint.surface || this.nextControlPoint.surface || _.some(this.trackPoints, p => p.surface))) {
      return false
    }
    return this.route.map.opts.showSurface
  },

  // draws the polyline, and control point (if required), and adds to map
  render: function() {
    if (!this.route.active && (!this.route.map || !this.route.drawInactive)) return;
    if (this.gPolylines.length > 0) {
      this.gPolylines.forEach(pl => pl.setMap(null));
    }
    if (this.sPolylines.length > 0) {
      this.sPolylines.forEach(pl => pl.setMap(null));
    }
    if (this.backgroundPolyline) this.backgroundPolyline.setMap(null);
    var route = this.route;
    // get some 'local state'
    var surfaceIndices = this.surfaceIndices && this.surfaceIndices.map(i => i);
    var trackPoints = [];
    var lls = [];
    if (this.prevControlPoint.point) {
      lls.push(this.prevControlPoint.googleLatLng());
      trackPoints.push(this.prevControlPoint)
    }
    for (var i = 0; i < this.trackPoints.length; i++) {
      var tp = this.trackPoints[i]
      if (tp.point) {
        lls.push(tp.googleLatLng());
        trackPoints.push(tp)
      }
    }
    if (this.nextControlPoint.point) {
      lls.push(this.nextControlPoint.googleLatLng());
      trackPoints.push(this.nextControlPoint)
    }
    if (this.prevControlPoint.point) {
      trackPoints.unshift(this.prevControlPoint)
    }
    // make sure there's something to render or gmaps will throw errors
    const slices = [];
    if (lls.length > 0 && lls[0]) {
      // SURFACE: slice lls on surface change boundaries so we can render multiple polylines
      if (this.showSurface() && route.active && surfaceIndices.length > 0) {
        let lastSIdx = 0;
        surfaceIndices.forEach(sIdx => {
          // this is sIdx + 1 to avoid gaps
          slices.push([lls.slice(lastSIdx, sIdx + 1), trackPoints[sIdx - 1].surface]);
          lastSIdx = sIdx
        })
        slices.push([lls.slice(lastSIdx), trackPoints[trackPoints.length - 1].surface])
      } else {
        const surface = trackPoints.length > 0
          ? trackPoints[trackPoints.length - 1].surface
          : this.nextControlPoint.surface
        slices.push([lls, surface])
      }

      var style, backgroundStyle;
      if(route.active && !this.excludeFromMetrics) {
        slices.forEach(([llSlice, surface]) => {
          var sliceSurface = rwgps.surfaces && rwgps.surfaces.surfaceGroups[`${surface}`]

          style = {
            strokeColor: this.cssColor(),
            strokeOpacity: Routes.heatmapEnabled ? 1 : 0.6,
            strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH,
            zIndex: 1
          }

          if (this.map.inPlanningMode() && Routes.heatmapEnabled) {
            // draw route lines with a white casing if the heatmap is on
            backgroundStyle = {
              strokeColor: rwgps.Segment.cssColor(0xffffff),
              strokeOpacity: 1,
              strokeWeight: 7,
              zIndex: 0,
              path: lls,
              clickable: false
            };
            this.backgroundPolyline = new google.maps.Polyline(backgroundStyle);
          }


          this.gPolylines.push(new google.maps.Polyline(_.extend(style, {
            path: llSlice,
            clickable: false
          })));

          if (this.showSurface() && sliceSurface !== 'paved') {
            this.surfacePolyline(llSlice, sliceSurface)
          }
        });
      } else {
        this.gPolylines.push(new google.maps.Polyline(_.extend(
          route.inactiveStyle || {
            strokeColor: '#000000',
            strokeOpacity: 0.2,
            strokeWeight: 5
          },
          {
            path: lls,
            clickable: false
          })
        ))
      }
      this.addToMap();
    }
  },
  //TODO: memoize for a performance improvement while drawing routes
  cssColor: function() {
    return rwgps.Segment.cssColor(this.color);
  },

  surfacePolyline: function(lls, surface) {
    if (surface === 'unpaved') {
      var icon = {
        path: "M 0.5,-1.5 0.5,1.5 -0.5,1.5 -0.5,-1.5",
        strokeOpacity: 0.9,
        strokeColor: '#FFFFFF',
        scale: 1
      };
      this.sPolylines.push(new google.maps.Polyline({
        strokeOpacity: 0,
        zIndex: 2,
        path: lls,
        clickable: false,
        icons: [{
          icon: icon,
          offset: "0",
          repeat: "6px"
        }]
      }));
    } else {
      this.sPolylines.push(new google.maps.Polyline({
        strokeOpacity: 0.9,
        strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH / 2,
        strokeColor: '#FFFFFF',
        zIndex: 2,
        path: lls,
        clickable: false
      }));
    }
  },

  drawControlPoint: function(map) {
    if(map) this.map = map;
    else map = this.map;

    if (this.drawInactive) return;

    if(this.controlPointIcon) {
      this.controlPointIcon.gmarker.setMap(map.gmap);
      var pt = this.nextControlPoint;
      this.controlPointIcon.gmarker.setPosition(pt.googleLatLng());
      this.controlPointIcon.trackPoint = pt;
    } else {
      this.redrawControlPoint(map);
    }
  },

  redrawControlPoint: function(map) {
    if(this.controlPointIcon) this.controlPointIcon.gmarker.setMap(null);
    var pt = this.nextControlPoint;
    var icon = new rwgps.ControlPointIcon(pt, map);
    this.controlPointIcon = icon;
  },

  //remove all map overlays from the map by setting to null
  //TODO: should this also null out this.map or anything else destructive?
  removeFromMap: function() {
    if (this.map) {
      this.map.removeSegmentDistanceMarkers(this)
      this.map = null;
    }
    if(this.gPolylines.length > 0) this.gPolylines.forEach(pl => pl.setMap(null));
    if(this.sPolylines.length > 0) this.sPolylines.forEach(pl => pl.setMap(null));
    if(this.backgroundPolyline) this.backgroundPolyline.setMap(null);
    if(this.controlPointIcon) this.controlPointIcon.gmarker.setMap(null);
    for(var i = 0; i < this.coursePoints.length; i++) {
      var cp = this.coursePoints[i];
      if(cp.marker && cp.marker.gmarker)
        this.coursePoints[i].marker.gmarker.setMap(null);
    }
  },

  addToMap: function(map) {
    if(map) this.map = map;
    if(!this.map) return;
    if(this.backgroundPolyline) this.backgroundPolyline.setMap(this.map.gmap);
    if(this.gPolylines.length > 0) {
      this.gPolylines.forEach(pl => {
        pl.setMap(this.map.gmap)
      });
      if (this.map.opts.showSurface) {
        this.sPolylines.forEach(pl => pl.setMap(this.map.gmap));
      }
    }
    if(this.map.showControlPointIcons && this.route.active) {
      this.drawControlPoint(this.map);
    }
  },

  /*
   *creating a coursepoint manually, we have to insert the coursepoint
   * in the appropriate place in the route's list
   */
  insertCoursePoint: function(cp) {
    for(var i = this.coursePoints.length-1; i >= 0; i--) {
      var pt = this.coursePoints[i];
      if(pt.distance <= cp.distance) { //here is our spot
        this.coursePoints.splice(i+1, 0, cp);
        cp.segment = this;
        return; //IMPORTANT!  can't fall through, since we add by default
      }
    }
    //fall through - either there are no coursepoints on this segment,
    //or we tried to add a coursepoint to beginning of segment, before
    //any other coursepoints.  So, add to beginning
    this.coursePoints.unshift(cp);
    cp.segment = this;
  },
  removeCoursePoint: function(cp) {
    if(cp.row) cp.row.remove();
    if(cp.marker && cp.marker.gmarker) cp.marker.gmarker.setMap(null); //remove from the map
    var idx = _.indexOf(cp.segment.coursePoints, cp)
    this.coursePoints.splice(idx, 1);
  },
  clearCoursePointMarkers: function() {
    for(var j = 0; j < this.coursePoints.length; j++) {
      if(this.coursePoints[j].marker)
        this.coursePoints[j].marker.gmarker.setMap(null);
    }
  },

  insertTrackPointAfter: function(point, index) {
    this.trackPoints.splice(index + 1, 0, point);
    this.calculateSurfaceIndices();
    var prevPoint = index < 0 ? this.prevControlPoint : this.trackPoints[index];
    point.distance = prevPoint.distance + point.distanceFromPoint(prevPoint);
    point.segment = this;
    this.route.segmentsChanged();
  },

  // Before: segment: <cp1,p2,p3,cp4>   this: <cp5,p6,p7,cp8>
  // After:  <cp1,p2,p3,<cp4>,p5,p6,p7,cp8>
  connectAfter: function(segment) {
    this.prevControlPoint.ensureNotControlPoint();
    segment.nextControlPoint.setControlPoint(segment, this);
  },

  /*
  * returns the newly created segment. if the segment being split
  * is on a route, the new segment is automatically spliced into
  * the route after the old, shortened segment.
  */
  splitAfter: function(index) {
    var spliceAt = index + 1;
    if(spliceAt > this.trackPoints.length-1) {
      if(spliceAt > 0 && spliceAt === this.trackPoints.length) {
        // trying to split after the last point, just back it up and it'll be ok
        spliceAt--;
      } else {
        // either spliceAt is way too big or there are no trackpoints, either way it's no good let's bail
        return;
      }
    }

    var howMany = this.trackPoints.length - spliceAt;
    var coursePoints = [];

    // reassign any relevant coursepoints
    for(var i = 0; i < this.coursePoints.length; i++) {
      var cp = this.coursePoints[i];
      var cpIdx = _.indexOf(this.trackPoints, cp.trackPoint);
      if(cpIdx > spliceAt) {
        coursePoints = this.coursePoints.splice(i);
        break;
      }
    }

    var trackPoints = this.trackPoints.splice(spliceAt, howMany);
    this.calculateSurfaceIndices();
    var nextControlPoint = this.nextControlPoint;
    var prevControlPoint = trackPoints.shift();
    prevControlPoint.setPrevSegment(this);

    var newSegment = new rwgps.Segment(this.route, prevControlPoint, nextControlPoint, trackPoints, coursePoints, this.color);

    newSegment.clickOptions.setOptions(this.clickOptions.getOptions());

    // gotta make new polylines for the segments using their new points
    this.render();
    newSegment.render();

    // if this segment is on a route, we'll auto-add the newsegment onto the route
    // as well as draw the control point icons (total redraw, inefficient)
    if(this.route) {
      // finally, add the control point icon.
      // TODO: small performance gain for doing this logically (insert and draw 1)
      this.route.clearControlPoints();
      if(this.map && this.map.mode != 'view') {
        this.route.drawControlPoints(this.map);
      }
    }
    return newSegment;
  },

  /*
  * merge with subsequent segment in route
  */
  slurpNext: function() {
    // absorb the control point and next segment's trackpoints and coursepoints
    var nextSegment = this.nextSegment;
    if(!nextSegment) return; // end of the line
    this.coursePoints = this.coursePoints.concat(nextSegment.coursePoints);
    var absorbedControlPoint = this.nextControlPoint;
    absorbedControlPoint.ensureNotControlPoint();
    absorbedControlPoint.segment = this;
    this.trackPoints.push(absorbedControlPoint);
    this.trackPoints = this.trackPoints.concat(nextSegment.trackPoints);
    // make sure the trackpoints and coursepoints reference this segment now
    for(var i=0,len=nextSegment.coursePoints.length; i < len; i++) { nextSegment.coursePoints[i].segment = this }
    for(i=0,len=nextSegment.trackPoints.length; i < len; i++) { nextSegment.trackPoints[i].segment = this }
    // tell the next control point who owns it now
    nextSegment.nextControlPoint.setPrevSegment(this);

    //gotta make new polylines for the segments using their new points
    nextSegment.removeFromMap();
    this.render();

    this.route.segmentsChanged(); // recalc # segments and cache
  }
}
rwgps.Segment.fillTheCracks = function(rawPoints) {
  var points = [];

  for(var i = 1; i < rawPoints.length; i++) {
    var first = rawPoints[i-1];
    var last = rawPoints[i];
    var distance = last.distanceFromPoint(first);
    var numPoints = Math.floor((distance / 1000) * 10.0);
    var yDistance = last.point.lat - first.point.lat;
    var xDistance = last.point.lng - first.point.lng;
    var latTicksPerDiv = yDistance / numPoints;
    var lngTicksPerDiv = xDistance / numPoints;
    var lat = first.point.lat;
    var lng = first.point.lng;
    points.push(first);

    // Ok, so now we know the x and y spacings between points, we can find
    // points on the hypotenuse that is the line between our two real points
    for(var j = 0; j < numPoints; j++) {
      const tp = new rwgps.TrackPoint({point: {lat, lng}})
      if (rwgps.config.labs.surface_types && rwgps.config.labs.route_planner) { // SURFACE: 99 is 'unknown'
        tp.surface = 99;
        tp.ghSurface = 99;
      }
      points.push(tp);
      lat += latTicksPerDiv;
      lng += lngTicksPerDiv;
    }
  }
  points.push(rawPoints[rawPoints.length-1]);
  return points;
}



// WEBPACK FOOTER //
// ./public/javascripts/js_maps/route.js